import { incYenOf, incOf } from '../lib/pricing';
export const clinicHero = {
  title: '医療・美容クリニック向け 法人研修',
  titleEn: 'FOR CLINICS & PRIVATE MEDICAL',
  lead: 'クリニック向け研修は、自由診療にふさわしい接遇と気遣いを、執事の基準で院内に定着させるプログラムです。',
};

export const clinicTrustBadges = [
  {
    icon: 'ri-empathize-line',
    text: '不安に寄り添う所作を「手順」として体系化',
  },
  {
    icon: 'ri-calendar-check-line',
    text: '診療後の夜間・休診日の出張実施に対応',
  },
  {
    icon: 'ri-user-star-line',
    text: '執事養成課程と同一の講師陣',
  },
];

export const clinicPainPoints = [
  {
    icon: 'ri-heart-pulse-line',
    text: '高単価の自由診療では、接遇そのものが医院選びの理由になっています。技術の高さに加え、「ここなら安心して任せられる」という印象を、患者様が院内に入った瞬間から感じられるかが問われています。',
  },
  {
    icon: 'ri-chat-smile-2-line',
    text: '受付・カウンセラーの言葉遣いや所作にばらつきがあります。スタッフの経験年数や性格に依存した接遇では、医院全体としての統一感が損なわれ、患者様の信頼感にも影響を及ぼします。',
  },
  {
    icon: 'ri-mental-health-line',
    text: '不安や緊張を抱えた患者様への距離感が個人任せになっています。「過度に踏み込みすぎず、それでいて冷たくない」距離の取り方を、感覚ではなく共通の型として院内に定着させたいという声を多くいただきます。',
  },
  {
    icon: 'ri-scales-line',
    text: '費用や施術内容など、デリケートな話題の伝え方を統一したい。治療の説明やお断りの場面では、一言の言い回しで患者様の安心感が大きく変わります。全スタッフが同じ水準で対応できる体制が必要です。',
  },
];

export const whyButlerWorks = [
  {
    icon: 'ri-empathize-line',
    title: '相手の体調や気分の機微を察して動く執事の技術が、患者様への寄り添いと重なる',
    description:
      '執事は、主の体調や気分のわずかな変化を察知し、求められる前に先回りして動く職業です。この「察する技術」は、不安や緊張を抱えてご来院される患者様への寄り添いとそのまま重なります。気持ち任せにせず、所作と手順で揃えます。',
  },
  {
    icon: 'ri-shield-keyhole-line',
    title: '守秘とプライバシー配慮を「気持ち」ではなく「所作と手順」として教えられる',
    description:
      '「患者様のプライバシーを大切に」という掛け声だけでは、現場での実践にばらつきが出ます。執事教育では、声のトーン、書類の差し出し方、案内の動線に至るまで、守秘を「見える所作」に落とし込んで訓練します。',
  },
  {
    icon: 'ri-team-line',
    title: 'ご案内・お茶出し・お見送りの型を整えることで、誰が対応しても同じ品質を保てる',
    description:
      'ベテランだからできる接遇ではなく、新人・パートスタッフでも再現できる「型」として接遇を設計します。ご案内の先導、お茶の出し方、お見送りの引き際——一つひとつの所作を標準化することで、院内の誰が対応しても患者様に同じ安心感をお届けできます。',
  },
];

export const recommendedPrograms = [
  {
    title: '半日プラン例',
    duration: '3時間',
    price: incYenOf('ct-single-halfday'),
    modules: 'M1（立ち居振る舞い）＋ M2（距離感・守秘・言葉遣いの原則）',
    description:
      '立ち居振る舞いの基本と、医療現場に不可欠な距離感・守秘の原則を集中的に学ぶ短期プランです。導入研修として、まずは全スタッフの土台を揃える目的に最適です。',
  },
  {
    title: '1日プラン例',
    duration: '6時間',
    price: incYenOf('ct-single-fullday'),
    modules: 'M1 ＋ M2 ＋ M3（ご案内・お茶出し実技）＋ M4（デリケートな場面のロールプレイング）',
    description:
      '所作からデリケートな場面の実技対応まで、クリニック接遇の基盤を1日で網羅する推奨プランです。診療後の夜間開催・休診日開催にも対応します。',
    recommended: true,
  },
  {
    title: '継続プログラム',
    duration: '月1回半日（3時間）×6ヶ月',
    price: incYenOf('ct-advisory-continuous6'),
    modules: '全6モジュールを6回で段階的に習得',
    description:
      '新人の受け入れや接遇基準の定着に推奨のプランです。月1回のペースで段階的に全モジュールを習得し、定期的な振り返りにより接遇品質の継続的な維持・向上を図ります。',
  },
];

export const clinicScenarios = [
  {
    number: '01',
    title: '受付からご案内まで',
    description:
      'ご来院時の第一声、動線の先導、待合室でのお声がけからカウンセリング室へのご案内までを、プライバシーに配慮した所作で通し演習します。受付での視線の合わせ方、カルテや同意書を差し出す角度と距離、他の患者様の目に触れない動線の選び方——すべてを実技で確認します。',
  },
  {
    number: '02',
    title: 'カウンセリング室での接遇',
    description:
      'お茶出しのタイミングと所作、資料の差し出し方、費用のご説明時の言葉選びと間の取り方をロールプレイングします。患者様の目線に合わせた着席位置、説明資料を広げる角度、金額を告げる際の自然な間——接遇の細部が患者様の安心感を左右します。',
  },
  {
    number: '03',
    title: 'デリケートな場面での対応',
    description:
      '施術への不安をお持ちの患者様への応対、予算のご相談を受けた際の言い回し、お断りせざるを得ないご要望への対応を、安心感を損なわない言い回しで練習します。「安全第一」の姿勢を崩さず、それでいて患者様の尊厳を守る伝え方を、実技で繰り返し訓練します。',
  },
];

export const clinicTargetRoles = [
  '受付・コンシェルジュ',
  'カウンセラー',
  '看護師・歯科衛生士（接遇場面）',
  '事務長・院長',
  '電話応対担当',
];

export const clinicPricingPlans = [
  {
    name: '半日プラン',
    duration: '3時間',
    price: incYenOf('ct-single-halfday'),
    note: '2モジュール選択',
  },
  {
    name: '1日プラン',
    duration: '6時間',
    price: incYenOf('ct-single-fullday'),
    note: '4モジュール選択',
    recommended: true,
  },
  {
    name: '2日間パッケージ',
    duration: '2日間（各6時間）',
    price: incYenOf('ct-single-2day'),
    note: '全モジュール対応',
  },
  {
    name: '継続プログラム',
    duration: '月1回半日×6ヶ月',
    price: incYenOf('ct-advisory-continuous6'),
    note: '全6モジュールを段階的に習得',
  },
];

export const clinicPricingConditions = {
  dispatch: '出張時の交通費は実費別途',
  capacity: '推奨12名まで。小規模院は2〜3名でも実施可能です（その分、お一人あたりの実技時間を厚く設計します）。',
  payment: 'お支払いは請求書払い（銀行振込）。分割払い・クレジットカードはご利用いただけません。',
  cancel: 'キャンセルについて：実施7営業日前まで無償で日程変更可。6営業日前〜前々日は料金の50％、前日・当日は100％を申し受けます。',
  nightAvailable: '診療後の夜間開催・休診日開催に対応します。',
};

export const clinicFlowSteps = [
  {
    step: '01',
    title: 'お問い合わせ',
    description: 'フォームまたはお電話・メールにてご連絡ください。',
  },
  {
    step: '02',
    title: 'ヒアリング',
    description:
      '診療科目・課題・対象人数・ご希望時期などをオンラインまたはお電話で伺います。事前に研修内容資料をお送りすることも可能です。',
  },
  {
    step: '03',
    title: 'プログラム提案・お見積り',
    description:
      'ヒアリング内容をもとに、貴院に最適な研修プログラムとお見積りをご提案します。概算お見積りのみのご依頼でも構いません。稟議のご準備にもご活用いただけます。',
  },
  {
    step: '04',
    title: '実施',
    description:
      '出張または来校にて研修を実施します。出張型では貴院の待合室・カウンセリング室を使用し、実際の動線で訓練することで研修翌日からの再現性が高まります。診療後の夜間や休診日など、診療に影響しない日程でご提案します。',
  },
  {
    step: '05',
    title: '実施後レポート',
    description: '研修の総括と改善提案をまとめたレポートをお届けします。',
  },
];

export const clinicMedicalFieldOptions = [
  { value: '', label: '選択してください' },
  { value: 'beauty', label: '美容' },
  { value: 'aesthetic-dentistry', label: '審美歯科' },
  { value: 'health-checkup', label: '人間ドック' },
  { value: 'other-private', label: 'その他自由診療' },
  { value: 'other', label: 'その他' },
];

export const clinicFormatOptions = [
  { value: '', label: '選択してください' },
  { value: 'dispatch', label: '出張' },
  { value: 'onsite', label: '来校' },
  { value: 'undecided', label: '未定' },
];

export const clinicFaqs = [
  {
    question: '執事の資格が取れる研修ですか？',
    answer:
      'いいえ。執事の接遇スキルに基づくビジネスマナー研修であり、資格を付与するものではありません。ご希望に応じて受講証（参加証明）を発行します。',
  },
  {
    question: '診療後の夜間や休診日に実施できますか？',
    answer:
      'はい、対応します。開始時刻と会場条件をヒアリング時にお知らせください。診療に影響しない日程でご提案いたしますので、ご希望の時間帯をお気軽にご相談ください。',
  },
  {
    question: '一般的な医療接遇マナー研修と何が違いますか？',
    answer:
      '患者様おひとりに「仕える」設計である点です。動作のマナーにとどまらず、距離感・守秘・デリケートな話題の伝え方までを実技で扱います。一般的な医療接遇研修が「してはいけないこと」の確認に終始しがちなのに対し、本研修は「すべきこと」を型として身につける実技訓練です。',
  },
  {
    question: '受付2名だけの小規模でも依頼できますか？',
    answer:
      'はい、可能です。料金はプラン単位のため少人数でも同額ですが、その分お一人ずつの実技時間を厚く設計します。講師が1対1に近い密度で指導しますので、むしろ少人数のほうが細部まで行き届いた訓練が可能です。',
  },
];

export const clinicRelatedPages = [
  {
    title: 'ホテル・旅館',
    description: 'バトラーサービスの型を開業前に整える',
    href: '/corporate/hotel',
  },
  {
    title: '高級レジデンス',
    description: 'コンシェルジュ・フロントの接遇品質を統一',
    href: '/corporate/residence',
  },
  {
    title: '金融・プライベートバンク',
    description: '富裕層営業の所作と距離感を鍛える',
    href: '/corporate/finance',
  },
  {
    title: '百貨店外商・高級小売',
    description: 'お得意様対応と訪問の作法を底上げ',
    href: '/corporate/retail',
  },
  {
    title: 'ラグジュアリー営業',
    description: '高級車・宝飾・不動産の商談体験を設計',
    href: '/corporate/luxury-sales',
  },
  {
    title: '自動車・モビリティ',
    description: 'ブランド体験の接遇を高める',
    href: '/corporate/automotive',
  },
  {
    title: 'ハイヤー・送迎',
    description: '乗降の所作と車内の気配りを磨く',
    href: '/corporate/chauffeur',
  },
];